import * as types from "../actionTypes";

export const submitCorporateStep = (data, navigate) => ({
  type: types.SUBMIT_CORPORATE_STEP,
  payload: { data, navigate },
});

export const submitCorporateStepSuccess = (data) => ({
  type: types.SUBMIT_CORPORATE_STEP_SUCCESS,
  payload: data,
});

export const submitCorporateStepFailure = (error) => ({
  type: types.SUBMIT_CORPORATE_STEP_FAILURE,
  payload: error,
});
